// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__k1BZ4","hiddenOverlay":"overlay_hiddenOverlay__NKbk2","overlayContent":"overlay_overlayContent__bJMV3"};